import {DigitalDocumentTypeEnum} from '@/services/api-clients';

const forceReceivedAllowedDigitalDocumentTypes = [DigitalDocumentTypeEnum.ReceivingProtocol, DigitalDocumentTypeEnum.BikeReceivingProtocol];

export function digitalDocumentTypeColorFilter(type: DigitalDocumentTypeEnum, isForcedReceive: boolean = false): [string, string] {
  if (forceReceivedAllowedDigitalDocumentTypes.includes(type) && isForcedReceive) return ['error', 'error--text'];

  switch (type) {
    case DigitalDocumentTypeEnum.LeaseAgreement: return ['yellow accent-4', 'yellow--text text--accent-4'];
    case DigitalDocumentTypeEnum.LoanAgreement: return ['primary', 'primary--text'];
    case DigitalDocumentTypeEnum.TransferProtocol: return ['blue accent-1', 'blue--text text--accent-1'];
    case DigitalDocumentTypeEnum.ReceivingProtocol: return ['blue accent-1', 'blue--text text--accent-1'];
    case DigitalDocumentTypeEnum.PromissoryNote: return ['error', 'error--text'];
    case DigitalDocumentTypeEnum.ContractOfMandateDriver: return ['primary', 'primary--text'];
    case DigitalDocumentTypeEnum.ContractOfMandateCourier: return ['success', 'success--text'];
    case DigitalDocumentTypeEnum.DeclarationLackOfSII: return ['warning', 'warning--text'];
    case DigitalDocumentTypeEnum.StudentStatusConfirmation: return ['purple', 'purple--text'];
    case DigitalDocumentTypeEnum.BikeTransferProtocol: return ['blue accent-1', 'blue--text text--accent-1'];
    case DigitalDocumentTypeEnum.BikeReceivingProtocol: return ['blue accent-1', 'blue--text text--accent-1'];
    case DigitalDocumentTypeEnum.GeneralProtocol: return ['teal lighten-1', 'teal--text text--lighten-1'];
    case DigitalDocumentTypeEnum.CashRegisterReceipt: return ['green darken-2', 'green--text text--darken-2'];
    case DigitalDocumentTypeEnum.CashRegisterDisbursement: return ['light-green lighten-1', 'light-green--text text--lighten-1'];
    default: return ['', ''];
  }
}
